import { LockedPositionRow } from "./LockedPositionRow";
import { UnlockPositionRow } from "./UnlockPositionRow";
import { LockedPositionSkeletonRow } from "./LockedPositionSkeletonRow";
import { useLockedPositionsTable } from "./useLockedPositionsTable";
import { memo, useMemo } from "react";
import { PortfolioPositionsTable } from "../PortfolioPositionsTable";
import { useUnwindingStore, type UnwindingPositionStore } from "@/hooks";
import { PositionStatus } from "../row/position-table-row.utils";
// import { useProtocolPNL } from "@/hooks/stores/useWalletAPYStore";

export const LockedPositionsTable = memo(() => {
    const { isLoading: isLockedLoading, table, rowModel } = useLockedPositionsTable();
    const { unwindingPositions, isLoading: isUnwindingLoading } = useUnwindingStore();
    // const { data: pnlData } = useProtocolPNL();

    const unwindingRows = useMemo(() => {
        if (!unwindingPositions?.length) {
            return [] as Array<{
                key: string;
                status?: PositionStatus;
                position: UnwindingPositionStore;
            }>;
        }
        const now = Date.now();

        return unwindingPositions.map((position, index) => {
            const endDateMs = Date.parse(position.endDate);
            const status = Number.isNaN(endDateMs)
                ? undefined
                : endDateMs > now
                  ? PositionStatus.UNLOCKING
                  : PositionStatus.UNLOCKED;

            return {
                key: position.id ? String(position.id) : `${position.lockDuration}-${position.startDate}-${index}`,
                status,
                position,
            };
        });
    }, [unwindingPositions]);

    const isLoading = isLockedLoading || (!rowModel.rows.length && isUnwindingLoading);

    return (
        <PortfolioPositionsTable
            positionType="locked"
            isLoading={isLoading}
            table={table}
            rowModel={rowModel}
            renderRow={(row, menuProps) => (
                <LockedPositionRow
                    key={row.id}
                    position={row.original}
                    index={row.index}
                    isMenuOpen={menuProps.isMenuOpen}
                    menuIndex={menuProps.menuIndex}
                    onMenuToggle={menuProps.onMenuToggle}
                    status={PositionStatus.EARNING}
                />
            )}
            renderExtraRows={(menuProps) =>
                unwindingRows.map((row, index) => (
                    <UnlockPositionRow
                        key={row.key}
                        position={row.position}
                        status={row.status}
                        index={rowModel.rows.length + index}
                        isMenuOpen={menuProps.isMenuOpen}
                        menuIndex={menuProps.menuIndex}
                        onMenuToggle={(event, rowIndex, nextStatus) =>
                            menuProps.onMenuToggle(event, row.position, rowIndex, nextStatus ?? row.status)
                        }
                    />
                ))
            }
            renderSkeletonRow={(index) => <LockedPositionSkeletonRow key={index} />}
        />
    );
});

LockedPositionsTable.displayName = "LockedPositionsTable";
